// extracted by mini-css-extract-plugin
export var bold = "_8Xr8W";
export var container = "xXIJB";
export var exerciseContent = "nbiOd";
export var exerciseInfo = "mSSb8";
export var exerciseInfoCell = "cXzR3";
export var exerciseNameCell = "qpSzA";
export var exerciseOrder = "Tdhab";
export var exerciseRest = "uGQ1z";
export var exerciseTitle = "_1--om";
export var image = "jgzdE";
export var step = "dm+la";
export var time = "PsBIB";